<template>
  <div class="homapt-button-wrapper">
    <div class="row">
      <div class="col text-center">
        <p class="homapt-social-button-text">{{ buttonText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    buttonText: String
  }
}
</script>

<style scoped>
.homapt-button-wrapper {
  margin: 5px 2px;
  border-radius: 5px;
  background-color: #feedaa;
  cursor: pointer;
  padding-top: 8px;
  padding-bottom: 8px;
}

.homapt-button-wrapper {
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.2);
}

.homapt-button-wrapper:active {
  box-shadow: none;
}

.homapt-social-button-text {
  color: black !important;
  margin-top: auto;
  margin-bottom: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/HomAptButton.vue